import React, { useState } from 'react';

import { Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ImageAvatar } from 'components/Avatar';
import { SEARCH_RESULTS_WIDTH, searchResultsListSx } from 'components/Form/GlobalSearch';
import { IconWrapper } from 'components/Icon';
import { useAuth } from 'lib/auth';
import { eligibleMemberships } from 'lib/companySwitch';

export const CompanySwitcher = () => {
  const { t } = useTranslation();
  const { account, user, switchCompany } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const otherMemberships = eligibleMemberships(account).filter((membership) => membership.user_id !== user?.user_id);
  if (!user || otherMemberships.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        aria-label={t('website:auth.switchCompany.menuLabel')}
        aria-haspopup="true"
        aria-expanded={Boolean(anchorEl)}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{
          borderRadius: 1.5,
          bgcolor: 'background.paper',
          color: 'text.secondary',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <IconWrapper
          icon="arrowsRightLeft"
          sx={({ palette }) => ({
            svg: {
              color: palette.background.paper,
              stroke: palette.primary.main,
              strokeWidth: 2,
            },
          })}
        />
        <Typography variant="button" sx={{ fontWeight: 700, fontSize: '0.625rem', lineHeight: 1.5 }}>
          {t('website:auth.switchCompany.label')}
        </Typography>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { width: SEARCH_RESULTS_WIDTH } }}
        MenuListProps={{ sx: searchResultsListSx }}
      >
        {otherMemberships.map((membership) => (
          <MenuItem key={membership.user_id} onClick={() => switchCompany(membership)}>
            <Stack direction="row" alignItems="center" gap={2} sx={{ img: { borderRadius: 1, width: 20, height: 20 } }}>
              <ImageAvatar img={membership.Company.square_logo_url || ''} name={membership.Company.Name} searchResult />
              <Typography variant="body1" fontWeight="bold">
                {membership.Company.Name}
              </Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
